import { DashboardPage } from '../components/pages/Dashboard';
import { AppProvider } from '../context/AppContext';
import { ContentProvider } from '../context/ContentContext';

export const PublicRoute = ({ isAuthenticated, children }) => {
	return isAuthenticated ? (
		<ContentProvider>
			<DashboardPage />
		</ContentProvider>
	) : (
		children
	);
};
